// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/activities/v1/fall.proto (package msh.trait.activities.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * @generated from message msh.trait.activities.v1.FallTrait
 */
export const FallTrait = proto3.makeMessageType(
  "msh.trait.activities.v1.FallTrait",
  [],
);

/**
 * @generated from message msh.trait.activities.v1.FallTrait.FallEvent
 */
export const FallTrait_FallEvent = proto3.makeMessageType(
  "msh.trait.activities.v1.FallTrait.FallEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "level", kind: "enum", T: proto3.getEnumType(FallTrait_FallEvent_FallLevel) },
    { no: 3, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
    { no: 4, name: "detected_by", kind: "enum", T: proto3.getEnumType(FallTrait_FallEvent_FallDetectedBy), repeated: true },
    { no: 5, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "FallTrait_FallEvent"},
);

/**
 * @generated from enum msh.trait.activities.v1.FallTrait.FallEvent.FallLevel
 */
export const FallTrait_FallEvent_FallLevel = proto3.makeEnum(
  "msh.trait.activities.v1.FallTrait.FallEvent.FallLevel",
  [
    {no: 0, name: "FALL_LEVEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FALL_LEVEL_MOVING", localName: "MOVING"},
    {no: 2, name: "FALL_LEVEL_NOT_MOVING", localName: "NOT_MOVING"},
  ],
);

/**
 * Deprecated
 *
 * @generated from enum msh.trait.activities.v1.FallTrait.FallEvent.FallDetectedBy
 */
export const FallTrait_FallEvent_FallDetectedBy = proto3.makeEnum(
  "msh.trait.activities.v1.FallTrait.FallEvent.FallDetectedBy",
  [
    {no: 0, name: "FALL_DETECTED_BY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "FALL_DETECTED_BY_RADAR", localName: "RADAR"},
    {no: 2, name: "FALL_DETECTED_BY_AUDIO", localName: "AUDIO"},
    {no: 3, name: "FALL_DETECTED_BY_ACCELEROMETER", localName: "ACCELEROMETER"},
  ],
);

